import styled from '@emotion/styled'

import { useHelpTextId } from '../../../hooks/useHelpTextId'
import { spacing } from '../../../theme'
import { Flex } from '../../layout/Flex'
import Text from '../../Text/Text'
import ArcadeCheckbox, { ArcadeCheckboxProps } from '../CheckboxInput/ArcadeCheckbox'
import ArcadeHelpText, {
  ArcadeHelpTextComponentProps,
  combineAriaDescribedBy,
  extractHelpTextProps,
} from '../Input/ArcadeHelpText'
import ArcadeRadioButton, { ArcadeRadioButtonProps } from '../RadioButton/ArcadeRadioButton'

const FocusContainer = styled(Flex)`
  border-radius: 0.25rem;
  ${({ theme }) => theme.selectors.keyboard} label:has(input:focus) & {
    outline: 0.125rem solid ${({ theme }) => theme.arcadeColors.component.inputBorderFocus};
    outline-offset: 0.25rem;
  }
`

const InputInlineLabel = styled.label`
  position: relative;
`

interface CheckboxInlineProps extends ArcadeCheckboxProps, ArcadeHelpTextComponentProps {
  label: string
  InputInlineComponent: typeof ArcadeCheckbox
}

interface RadioButtonInlineProps extends ArcadeRadioButtonProps, ArcadeHelpTextComponentProps {
  label: string
  InputInlineComponent: typeof ArcadeRadioButton
}

export type InputInlineProps = CheckboxInlineProps | RadioButtonInlineProps

const InputInline = (props: InputInlineProps) => {
  const { label, InputInlineComponent, disabled = false, 'aria-describedby': ariaDescribedBy, ...restProps } = props
  const helpTextProps = extractHelpTextProps(props)
  const helpTextId = useHelpTextId(helpTextProps)

  return (
    <>
      <InputInlineLabel>
        <FocusContainer flexDirection="row" gap={spacing.s}>
          <InputInlineComponent
            disabled={disabled}
            aria-describedby={combineAriaDescribedBy(ariaDescribedBy, helpTextId)}
            {...restProps}
          />
          <Text typography="body" color={disabled ? 'textDisabled' : 'textSubtle'}>
            {label}
          </Text>
        </FocusContainer>
      </InputInlineLabel>
      <ArcadeHelpText helpTextId={helpTextId} {...helpTextProps} />
    </>
  )
}
export default InputInline
